import {
  CreateConnectAccountRequest,
  CreateOnboardingLinkRequest,
  OnboardingLinkResponse,
  ConnectAccountResponse,
  PlatformFeeConfiguration,
  StripeProcessingFeeConfiguration,
} from "@/types/breeze/StripeConnect";
import { BaseService } from "../BaseService";

export class StripeConnectService extends BaseService {
  // Get the tenant's Stripe Connect account (or null if not set up)
  public async getTenantConnectAccount(): Promise<ConnectAccountResponse> {
    return this.getRequest("/integrations/anythinkpay/stripe-connect");
  }

  // Create a new Stripe Connect account for the tenant
  public async createConnectAccount(
    request: CreateConnectAccountRequest,
  ): Promise<ConnectAccountResponse> {
    return this.postRequest(
      "/integrations/anythinkpay/stripe-connect",
      request,
      "Stripe Connect account created successfully",
    );
  }

  // Create onboarding link for the tenant's Connect account
  public async createOnboardingLink(
    request: CreateOnboardingLinkRequest,
  ): Promise<OnboardingLinkResponse> {
    return this.postRequest(
      "/integrations/anythinkpay/stripe-connect/onboarding",
      request,
      "Onboarding link created successfully",
    );
  }

  // Get platform fee configuration
  public async getPlatformFeeConfiguration(): Promise<PlatformFeeConfiguration> {
    return this.getRequest("/integrations/anythinkpay/stripe-connect/fees");
  }

  // Get OAuth URL to connect an existing Stripe account
  public async getOAuthUrl(redirectUri: string): Promise<{ url: string }> {
    return this.getRequest(`/integrations/anythinkpay/stripe-connect/oauth/url?redirectUri=${encodeURIComponent(redirectUri)}`);
  }

  // Exchange OAuth code for connected account
  public async exchangeOAuthCode(code: string): Promise<ConnectAccountResponse> {
    return this.postRequest(
      "/integrations/anythinkpay/stripe-connect/oauth/callback",
      { code },
      "Stripe account connected successfully",
    );
  }

  // Get Stripe processing fee configuration
  public async getStripeProcessingFeeConfiguration(): Promise<StripeProcessingFeeConfiguration> {
    return this.getRequest(
      "/integrations/anythinkpay/stripe-connect/stripe-fees",
    );
  }
}

export const stripeConnectService = new StripeConnectService();
